import { render, staticRenderFns } from "./ResultsList.vue?vue&type=template&id=d456cc54&"
import script from "./ResultsList.vue?vue&type=script&lang=js&"
export * from "./ResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports